import { useState, useEffect, Fragment, useRef } from "react";
import FileInput from "react-fine-uploader/file-input";
import FineUploaderS3 from "fine-uploader-wrappers/s3";
import "react-fine-uploader/gallery/gallery.css";
import Utils from "../../../../utils/index.js";
import { t } from "i18next";
import { toast } from "react-toastify";
import axios from "axios";
import _ from "lodash";
const FileUploadComponent = ({
  id,
  referenceId,
  setProgressVisible,
  multipleFiles = [],
  description,
  title = () => {},
  setUploadProgress,
  setFilelist,
  fetchFiles,
  instanceId,
  fileProcessing,
  progress,
  setProgress,
  handleFormBlur,
  fromWorkflow = false,
  assistantData,
  workflowUuid,
  isEditable,
  generateInstanceData,
}) => {
  const token = Utils.getLocalStorageItem("_t");
  const [config, setConfig] = useState(null);
  const [filesData, setFilesData] = useState("");
  const fileExtensions = config?.allowedTypes
    ? Utils.getAllowExtensions(config.allowedTypes)
        .map((ext) => `.${ext}`)
        .join(",")
    : "";
  // Default to an empty string if config is not available.
  // const [progress, setProgress] = useState(true);

  const latestFile = _.sortBy(multipleFiles, "createdAt").reverse();

  let size = 0;
  let instanceData;
  const fetchConfig = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}filehandler/config`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "X-Access-Token": token,
          },
        }
      );

      if (!response.ok) {
        console.error("Failed to fetch configuration!");
        return;
      }

      const configData = await response.json();
      setConfig(configData?.data);
    } catch (error) {
      console.error("Error fetching configuration:", error);
    }
  };
  var counter = 5;
  var count = 1;
  // const startSession = () => {
  //   const eventSource = new EventSource(
  //     `${process.env.REACT_APP_BASE_URL}/event/startSession/${token}`
  //   );

  //   eventSource.onmessage = (event) => {
  //     const receivedData = JSON.parse(event.data);

  //     if (receivedData?.status === "Y" && receivedData?.active == true) {
  //       toast.success("File processed successsfully !!");

  //       setFilelist((prev) => {
  //         return prev.map((data) => {
  //           if (data.fileName === receivedData.fileName) {
  //             data.status = "Y";
  //           }
  //           return data;
  //         });
  //       });
  //     }
  //   };

  //   // eventSource.onopen = () => {
  //   //   count = 1;
  //   // };

  //   // eventSource.onerror = (error) => {
  //   //   eventSource.close();

  //   //   startSession();
  //   // };

  //   // return () => {
  //   //   eventSource.close();
  //   //   clearTimeout(closeTimeout);
  //   // };
  // };
  useEffect(() => {
    fetchConfig();
    // startSession();
  }, []);

  // useEffect(() => {
  //   if (!progress && latestFile[0]?.status === "pending") {
  //     setTimeout(() => {
  //       fetchFiles();
  //     }, 10000);
  //   }
  // }, [progress]);
  const totalFilesCount = useRef(0);
  const completedFilesCount = useRef(0);

  const uploader = new FineUploaderS3({
    options: {
      debug: true,
      multiple: true,
      retry: { enableAuto: true, autoAttemptDelay: 5, maxAutoAttempts: 50 },
      chunking: {
        enabled: true,
        partSize: 5 * 1024 * 1024,
        concurrent: { enabled: true },
      },
      resume: { enabled: true, recordsExpireIn: 1 },
      objectProperties: {
        region: config?.confg?.region,
        key: function (fileId) {
          const FileName = this.getName(fileId);
          const FileWithUUId =
            config?.confg?.S3StoragePath +
            "/" +
            this.getUuid(fileId) +
            "." +
            FileName?.substr(FileName?.lastIndexOf(".") + 1);
          return FileWithUUId;
        },
      },
      request: {
        endpoint: `https://${config?.confg?.hostName}`,
        accessKey: config?.confg?.accessKeyId,
      },
      signature: {
        endpoint: `${process.env.REACT_APP_BASE_URL}filehandler/signature`,
        version: 4,
        customHeaders: {
          Accept: "application/json",
          "X-Access-Token": token,
        },
      },
      uploadSuccess: {},
      deleteFile: {
        enabled: true,
        endpoint: config?.confg?.hostName || "",
      },
      validation: {
        allowedExtensions: Utils.getAllowExtensions(config?.allowedTypes),
        sizeLimit: Utils.getAllowFileSize(config?.maxSizeEachFileInMB),
        itemLimit: Utils.getAllowFileLimitMulti(
          config?.maxFiles,
          multipleFiles.length
        ),
      },
      callbacks: {
        onValidateBatch: (fileOrBlobDataArray) => {
          let isValid = true;
          let existingFiles = new Set(
            [...multipleFiles].map((file) => file.fileName)
          );

          for (let file of fileOrBlobDataArray) {
            const FILE_NAME = file.name;

            if (existingFiles.has(FILE_NAME)) {
              toast.error(
                "One or more selected files have already been uploaded. Please remove duplicate files and try again."
              );
              setProgressVisible(false);
              isValid = false;
              break;
            }
          }

          if (!isValid) {
            return false;
          }

          return true;
        },
        onValidate: (fileOrBlobData) => {
          //   filesLengthMulti++;
          totalFilesCount.current++;
          const FILE_NAME = fileOrBlobData.name;
          //   if (filesLength > config.maxFiles) {
          //     toast.error("More than " + config.maxFiles + " files not allowed");
          //     return false;
          //   }
          let extension = fileOrBlobData?.name?.split(".")?.[1];
          // if (extension && Utils.getAllowExtensions(config?.allowedTypes).indexOf(extension) == -1) {
          //   const message = `${extension?.[0]?.toUpperCase() + extension?.slice(1, extension.length)} ${t('filesAreNotAllowed')}`;
          //   toast.error(message);
          //   return false;
          // }
          const FILE_EXTENSION = FILE_NAME.split(".").pop().toLowerCase();
          const ALLOWED_EXTENSIONS = Utils.getAllowExtensions(
            config?.allowedTypes
          );
          if (!ALLOWED_EXTENSIONS.includes(FILE_EXTENSION)) {
            toast.error(`File type .${FILE_EXTENSION} is not allowed.`);
            return false;
          }
          if (
            fileOrBlobData?.size >
            Utils.getAllowFileSize(config?.maxSizeEachFileInMB)
          ) {
            toast.error(
              `${FILE_NAME} is too large, Max file size limit is ${config?.maxSizeEachFileInMB} MB`
            );

            return false;
          }
          if (
            fileOrBlobData?.size >
            Utils.getAllowFileSize(config?.maxSizeEachFileInMB)
          ) {
            toast.error(
              `${FILE_NAME} is too large, Max file size limit is ${config?.maxSizeEachFileInMB} MB`
            );

            return false;
          }

          if (
            fileOrBlobData?.name &&
            fileOrBlobData?.size &&
            fileOrBlobData?.size 
          ) {
            setProgressVisible(true);
            size = fileOrBlobData.size;
            setFilelist((prev) => [
              ...prev,
              {
                fileName: fileOrBlobData?.name,
                size: fileOrBlobData?.size,
                status: "pending",
                type: FILE_NAME?.split(".")?.[FILE_NAME?.split(".").length - 1],
                isProcessed: false,
                step: 0,
                message: "File upload successful. Processing initiated...",
              },
            ]);
          }
          return true;
        },
        onComplete: async (id, name, response) => {
          setTimeout(() => {
            setUploadProgress(0);
            setProgressVisible(false);
          }, 2000);
          completedFilesCount.current++;
          if (response && response.success) {
            const fileKey = uploader.methods.getKey(id);
            if (fileKey) {
              let filesData = fileKey.split("/");
              filesData = filesData[filesData.length - 1];
              setFilesData(filesData);
              let assistantId = referenceId;
              if (!referenceId) {
                const response = await axios.post(
                  `${process.env.REACT_APP_BASE_URL}genai/generate_assistant_id`,
                  {},
                  {
                    headers: {
                      "X-Access-Token": token,
                      Accept: "application/json",
                    },
                  }
                );
                assistantId = response.data.assistantId;
              }
              if (fromWorkflow && !instanceId) {
                try {
                  const response = await generateInstanceData(assistantId);
                  instanceData = response.data;
                  instanceId = response.data.instanceUuid;
                } catch (error) {
                  console.log(error, "error");
                }
              }

              uploadFilesMulti(
                filesData,
                name,
                assistantId,
                completedFilesCount,
                totalFilesCount
              );
            }
          }
        },
        onError: (id, name, response, xhrOrXdr) => {
          setProgressVisible(false);
          if (response) {
            let errorMsg = "Something went wrong.";
            if (response.indexOf("size") > -1) {
              errorMsg = `${name} is too large, Max file size limit is ${config?.maxSizeEachFileInMB} MB`;
            }

            if (response.indexOf("extension") > -1) {
              errorMsg = `Valid extensions for uploading files are :${Utils.getAllowExtensions(
                config?.allowedTypes
              ).map((ele) => " " + ele)}.`;
            }

            if (response.indexOf("limit") > -1) {
              errorMsg = `You have left only ${Utils.getAllowFileLimit(
                0,
                multipleFiles.length
              )} files for now to upload`;
            }
          }
        },
        onProgress: (id, name, uploadedBytes, totalBytes) => {
          setProgress(true);

          setTimeout(() => {
            if (navigator?.onLine) {
              var percent = (uploadedBytes / totalBytes) * 100;
              setUploadProgress(percent);
            }
          }, 1000);
        },
        onCancel: (id, name) => {},
      },
    },
  });

  const uploadFilesMulti = async (filesData, name, reference = null) => {
    try {
      const addFileInfoResponse = await fetch(
        `${process.env.REACT_APP_API}filehandler/addfileinfo`,
        {
          method: "POST",
          body: JSON.stringify({
            referenceId: reference || referenceId,
            referenceType: "Instance",
            fileName: name,
            key: filesData,
            instanceUuid: instanceId,
            fileSize: size,
          }),
          headers: {
            "Content-Type": "application/json",
            "X-access-token": token,
          },
        }
      );
      const responseData = await addFileInfoResponse.json();
      if (!addFileInfoResponse.ok) {
        toast.error("Failed to add file info to MongoDB!");
      } else {
        if (
          completedFilesCount.current === totalFilesCount.current &&
          totalFilesCount.current !== 0
        ) {
          if (totalFilesCount.current > 1) {
            toast.success("Files added successfully!");
          } else {
            toast.success("File added successfully!");
          }
          completedFilesCount.current = 0;
          totalFilesCount.current = 0;
        }
      }
      setUploadProgress(100);
      setProgress(false);
      setFilelist((prev) => {
        const newFileList = prev.map((data) => {
          if (
            data?.status == "pending" &&
            responseData?.data?.fileName === data.fileName
          ) {
            data = {
              ...responseData?.data,
              size: data?.size,
              type: data?.type,
              step: data?.step,
              message: data?.message,
            };
            data.status = "pending";
          }
          
          return data;
        });
        if (fromWorkflow && typeof handleFormBlur === "function") {
        const fileTypeInput = {
          target: {
            name: id,
            value: newFileList.map(file => ({fileId: file._id})),
            instanceData,
          },
        };

          handleFormBlur(fileTypeInput);
        }
        return newFileList;
      });
    } catch (error) {
      console.error("Error uploading file:", error);
    }
  };

  return (
    <>
    {isEditable ?
    <Fragment>
      <div className="heading-box">
        <h4 className="instruct-title">{title}</h4>
      </div>
      <p className="mb-2 ulodt">{description}</p>
      <div className="upload-file-box">
        <div className="input-wrap-row-wrap">
          <div className="from-input-wrapper">
            <div className="input-wrap-row-wrap">
              <div className="from-input-wrapper">
                <div
                  className="file-uploader"
                  onClick={() => {
                    document.getElementById("fileUploader").click();
                  }}
                  style={{
                    cursor:
                      latestFile[0]?.status === "pending"
                        ? "not-allowed"
                        : "default",
                  }}
                >
                  <FileInput
                    uploader={uploader}
                    multiple
                    disabled={latestFile[0]?.status === "pending" || !isEditable}
                    id="fileUploader"
                    data-tooltip-id="upload-file-btn"
                    accept={fileExtensions}
                    data-tooltip-content={
                      multipleFiles?.length >= config?.maxFiles
                        ? `${t("multipleFilesUpload")} ${config?.maxFiles} ${t(
                            "files"
                          )}.`
                        : ""
                    }
                    title=""
                  >
                    <div
                      aria-disabled={
                        multipleFiles?.length >= config?.maxFiles ? true : false
                      }
                      className={`btn builderbtn mb-2 ${
                        multipleFiles?.length >= config?.maxFiles
                          ? "disabled"
                          : ""
                      }`}
                    ></div>
                  </FileInput>
                  <div className="fil-uplaod-icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="21"
                      height="20"
                      viewBox="0 0 21 20"
                      fill="none"
                    >
                      <path
                        d="M7.16699 13.3333L10.5003 10M10.5003 10L13.8337 13.3333M10.5003 10V17.5M17.167 13.9524C18.1849 13.1117 18.8337 11.8399 18.8337 10.4167C18.8337 7.88536 16.7816 5.83333 14.2503 5.83333C14.0682 5.83333 13.8979 5.73833 13.8054 5.58145C12.7187 3.73736 10.7124 2.5 8.41699 2.5C4.96521 2.5 2.16699 5.29822 2.16699 8.75C2.16699 10.4718 2.8632 12.0309 3.98945 13.1613"
                        stroke="#475467"
                        strokeWidth="1.66667"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>
                  <div className="linktext-upload">
                    <strong
                      style={{
                        cursor:
                          latestFile[0]?.status === "pending"
                            ? "not-allowed"
                            : "pointer",
                      }}
                    >
                      {t("clickToUpload")}
                    </strong>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
    :
    <div className="heading-box">
      <h4 className="instruct-title">Files</h4>
      </div>
    }
    </>
  );
};

export default FileUploadComponent;
